// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EoThE","rootNoMargin":"styles_rootNoMargin__27Uae"};